export default __webpack_public_path__ + "static/media/sec7bgimg.de408fb7.png";